export default function (Restangular, FlashService, $location) {
    return {
        restrict: 'E',
        scope: {
            entity: '=',
            entry: '='

        },
        link: function (scope, element) {
            scope.loading = false;

            scope.paymentInvoice = function () {
                let invoice = scope.entry.values;
                if(scope.loading){
                    return false;
                }

                scope.loading = true;

                return Restangular
                    .one("invoice", invoice.id)
                    .one("payment")
                    .withHttpConfig({responseType: 'blob'})
                    .get()
                    .then(response => {
                        scope.loading = false;
                        if(response.status == 204 || response.status == 200){
                            FlashService.Success('SUCCESS_PAYMENT');

                            $location.path('/payment/list');
                        }else{
                            FlashService.ERROR('ERROR_PAYMENT');
                        }
                    });
            }

        },
        template: '<a class="btn btn-default" ng-click="paymentInvoice()" ><i class="fa text-warning" ng-class="{\'fa-spinner fa-pulse\': loading, \'fa-refresh\': !loading}"></i><md-tooltip>Create a payment</md-tooltip></a>'
    };
};


/** WEBPACK FOOTER **
 ** ./js/directives/invoice_payment.js
 **/